<template>
    <div class="form-import-export ">
      <card  header-text='Import'>
        <basix-alert type="success" v-if='success' :withCloseBtn="true">
          <span class="badge badge-pill badge-success">Success</span>
          {{success}}
        </basix-alert>
        <p>Please use csv file and click on import button</p>
        <form @submit.prevent='' enctype="multipart/form-data">
          <div class="form-group ">

            <div class="upload-file1 ">
              <!-- Select Files -->
              <input id='file' name='csvfile' type="file"   @change='filesChange($event)'  >

             <submitButton @click='importCsv' class=" btn btn-primary">Import</submitButton>
            </div>
            <!-- <div class="help" v-if='selectedFile'>{{selectedFile}}</div> -->
          <p class="small">
          To download sample csv format <a :href="link" style='color:blue;font-size:1.2em'>click here</a>
          </p>

          </div>

        </form>
      </card>

    </div>
</template>
<script>
  import submitButton from "@/components/submitButton"
  import config from "@/lib/config"
  import http from "@/lib/http"
  export default  {
    components:{submitButton},
    data(){
      return {
        count:0,
        files:[],
        selectedFile:"",
        success:"",
        link: config.API_URL+'static/sample.csv'
      }
    },
    methods: {
      filesChange(evt) {
        let files = evt.target.files
        let field = evt.target.name
        if(files.length){
          this.selectedFile =""
          this.files = new FormData()
          for (let i = 0; i <files.length; i++){
            this.files.append(field,files[i])
            this.selectedFile += files[i].name
          }
        }
        console.log(evt.target.files);
      },
      importCsv(){
        let myself = this
        http.request("POST","http://localhost:5000/import",this.files,function(err,res){
          if(res){
            myself.success = res
            document.getElementById("file").value = null
          }
        })
      }
    }
  }
</script>
<style lang='scss'>
.upload-file {
 border: 1px solid;
 display:inline-block;
 position: relative;

 input{
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;
  left:0;
 }
}

</style>



// WEBPACK FOOTER //
// src/views/Import.vue